import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import useTheme from '@mui/system/useTheme';
import AnalyticsCurrentVisits from 'src/sections/overview/analytics/analytics-current-visits';

ChartJS.register(ArcElement, Tooltip, Legend);

const CostPoolPieChart: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const theme = useTheme();
  return (
    <Card>
      <CardContent>
        <Typography
          variant="h6"
          gutterBottom
          style={{
            display: 'flex',
            marginBottom: '0px',
            fontSize: '1.2rem',
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          Cost Pool Spend
          {/* <InfoIcon color="action" style={{ paddingLeft: '5px', color: '#4040ab' }} /> */}
        </Typography>
        <Typography
          color="grey"
          style={{ display: 'flex', fontWeight: '300', fontSize: ' 0.7rem' }}
        >
          This month (March 2024)
        </Typography>
        <Typography
          variant="h5"
          component="h2"
          gutterBottom
          style={{ fontWeight: '300', marginBottom: '0px' }}
        >
          OpEx
        </Typography>
        <AnalyticsCurrentVisits
        chart={{
          series: [
            {label:'License', value:412719},
      {label:'Annual Maintenance', value: 50000},
      {label:'Infrastructure', value: 72000},
      {label:'Staff', value: 385545},
      {label:'Hosting/On-prem', value: 92220},
      {label:'Server Upgrades', value: 440000},
      { label: 'Help Desk Support', value: 57799},
      {label:'Other', value: 0},
          ],
        }}
        />
      </CardContent>
    </Card>
  );
};

export default CostPoolPieChart;
